export default __webpack_public_path__ + "static/media/023-buttocks.47469b09.svg";